import script from "./CeciList.vue?vue&type=script&lang=ts&name=CeciList&setup=true"
export * from "./CeciList.vue?vue&type=script&lang=ts&name=CeciList&setup=true"

import "./CeciList.vue?vue&type=style&index=0&id=5de23c03&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de23c03"]])

export default __exports__